import React, { useEffect, useState } from "react";
import Modal from "../../../modal";
import useAppContext from "../../../../context/useAppContext";
import { customFetch } from "../../../../hooks/customFetch";

const QuizStepUygunluk = require("../../../../sources/Step1Q.json");
const QuizStepYerindelik = require("../../../../sources/Step1QPortfoy.json");
const QuizStepYerindelikAlnus = require("../../../../sources/Step1QPortfoyAlnus.json");
const QuizStepYerindelikMeksa = require("../../../../sources/Step1QPortfoyMeksa.json");
const SelectiveStepStandard = require("../../../../sources/Step2Q.json");
const QuizStepUygunlukIntegral = require("../../../../sources/Step1QIntegral.json");
const QuizStepYerindelikIntegral = require("../../../../sources/Step1QPortfoyIntegral.json");
const SelectiveStepIntegral = require("../../../../sources/Step2QIntegral.json");

const EMPTY_VALUE = "-";

const hasValue = (value) => value !== undefined && value !== null && value !== "";

const getFirstValue = (data, keys) => {
  const key = keys.find((item) => hasValue(data[item]));
  return key ? data[key] : undefined;
};

const formatValue = (value) => {
  if (!hasValue(value)) {
    return EMPTY_VALUE;
  }

  return value;
};

const formatGender = (value) => {
  if (value === "E") {
    return "Erkek";
  }
  if (value === "K") {
    return "Kadın";
  }
  if (value === "Erkek" || value === "Kadın") {
    return value;
  }
  return value;
};

const getQuizStep = (innerTexts) => {
  if (innerTexts.id === "ALNUSYATIRIM") {
    return QuizStepYerindelikAlnus;
  }
  if (innerTexts.id === "INTEGRALYATIRIM") {
    return innerTexts.yerindelik ? QuizStepYerindelikIntegral : QuizStepUygunlukIntegral;
  }
  if (innerTexts.id === "MEKSA") {
    return innerTexts.yerindelik ? QuizStepYerindelikMeksa : QuizStepUygunluk;
  }
  return innerTexts.yerindelik ? QuizStepYerindelik : QuizStepUygunluk;
};

const getSelectiveStep = (innerTexts) =>
  innerTexts.id === "INTEGRALYATIRIM" ? SelectiveStepIntegral : SelectiveStepStandard;

const getOptionText = (options, value) => {
  const option = options.find((item) => String(item.value) === String(value));
  return option?.text || value;
};

const buildTestRows = (data, innerTexts) => {
  const quizRows = getQuizStep(innerTexts)
    .map((item) => {
      const value = getFirstValue(data, [
        item.field,
        item.field === "tasarruf_tutar" ? "tasarruf_tutari" : item.field,
        item.field === "mali_yukumluluk_tutari" ? "mali_yukumluluk_tutar" : item.field,
      ]);

      return [item.question, getOptionText(item.options, value)];
    })
    .filter(([, value]) => hasValue(value));

  const selectiveRows = getSelectiveStep(innerTexts).flatMap((item) =>
    item.fields
      .map((field) => {
        const value = data[field.field];
        return [`${item.question} - ${field.text}`, getOptionText(field.buttons, value)];
      })
      .filter(([, value]) => hasValue(value) && value !== "\"0\"")
  );

  const resultRows = [
    ["Test Puanı", data.puan],
    ["Risk Profili", data.harf],
  ].filter(([, value]) => hasValue(value));

  return [...resultRows, ...quizRows, ...selectiveRows];
};

const buildRows = (data, tc, cepNo, innerTexts) => [
  {
    title: "Kimlik Bilgileri",
    rows: [
      ["TC Kimlik No", tc],
      ["Ad", getFirstValue(data, ["ad", "adi"])],
      ["Soyad", getFirstValue(data, ["soyad", "soyadi"])],
      ["Doğum Tarihi", getFirstValue(data, ["dogum_tarihi", "dogumTarihi"])],
      ["Doğum Yeri", getFirstValue(data, ["dogum_yeri", "dogumYeri"])],
      ["Anne Adı", getFirstValue(data, ["anne_adi", "anneAdi", "ana_adi"])],
      ["Baba Adı", getFirstValue(data, ["baba_adi", "babaAdi"])],
      ["Cinsiyet", formatGender(getFirstValue(data, ["cinsiyet", "gender", "cinsiyet_adi"]))],
      ["Kimlik Seri No", getFirstValue(data, ["kimlik_serino", "kimlik_seri_no", "kimlikSeriNo"])],
    ],
  },
  {
    title: "İletişim ve Adres Bilgileri",
    rows: [
      ["Cep Telefonu", cepNo],
      ["E-Posta", data.email],
      ["Ülke", data.ulke],
      ["İl", data.il],
      ["İlçe", data.ilce],
      ["Mahalle", data.mahalle],
      ["Cadde/Sokak", data.cadde_sokak],
      ["Dış Kapı", data.dis_kapi],
      ["İç Kapı", data.ic_kapi],
      ["Adres", data.adres],
      ["Posta Kodu", data.posta_kodu],
    ],
  },
  {
    title: "Yatırımcı Bilgileri",
    rows: [
      ["Meslek", data.meslek],
      ["Aylık Gelir", data.aylik_gelir],
      ["Toplam Mal Varlığı", data.toplam_mal_varligi],
      ["Mal Varlığı Kaynağı", data.mal_varlik_kaynagi],
      ["Meslek Tecrübe Yılı", data.meslek_tecrube_yili],
      ["Ekstre İletişim Tercihi", data.iletisim_tercihi],
      ["Şube", data.sube],
      ["Temsilci", data.temsilci],
    ],
  },
  {
    title:
      (innerTexts.yerindelik ? innerTexts.label_step_two_yerindelik : innerTexts.label_step_two) ||
      "Test Bilgileri",
    rows: buildTestRows(data, innerTexts),
  },
];

const fetchPreviewPart = (params, token) =>
  new Promise((resolve) => {
    customFetch({
      params,
      method: "GET",
      token,
      onSuccess: (response) => {
        resolve(response?.bilgiler || {});
      },
      onError: () => {
        resolve({});
      },
    });
  });

const mergeFilledValues = (...sources) =>
  sources.reduce((acc, source) => {
    Object.keys(source || {}).forEach((key) => {
      if (source[key] !== undefined && source[key] !== null && source[key] !== "") {
        acc[key] = source[key];
      }
    });
    return acc;
  }, {});

const FormPreviewModal = ({ show, onClose }) => {
  const { innerTexts, tc, cepNo, token } = useAppContext();
  const [previewData, setPreviewData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!show) {
      return;
    }

    setLoading(true);
    setError("");

    Promise.all([
      fetchPreviewPart("islem=kimlik_bilgileri_getir&step=1", token),
      fetchPreviewPart("islem=yatirimci_bilgileri_getir", token),
      fetchPreviewPart("islem=yatirimci_bilgileri_getir&step=3", token),
      fetchPreviewPart("islem=uygunluk_testi_getir&step=2", token),
    ])
      .then(([identityData, investorData, stepThreeData, testData]) => {
        setPreviewData(mergeFilledValues(investorData, identityData, stepThreeData, testData));
        setLoading(false);
      })
      .catch(() => {
        setError("Önizleme bilgileri alınırken bir hata oluştu.");
        setLoading(false);
      });
  }, [show, token]);

  const sections = buildRows(previewData, tc, cepNo, innerTexts);
  const visibleSections = sections
    .map((section) => ({
      ...section,
      rows: section.rows.filter(([, value]) => hasValue(value)),
    }))
    .filter((section) => section.rows.length > 0);

  return (
    <Modal show={show} title={innerTexts.formPreviewTitle || "Form Önizleme"} onClose={onClose}>
      {loading && <div className="alert alert-info">Bilgiler yükleniyor...</div>}
      {error && <div className="alert alert-danger">{error}</div>}
      {!loading && !error && (
        <>
          {visibleSections.map((section) => (
            <div key={section.title} style={{ marginBottom: 20 }}>
              <h4>{section.title}</h4>
              <table className="table table-bordered table-condensed">
                <tbody>
                  {section.rows.map(([label, value]) => (
                    <tr key={`${section.title}-${label}`}>
                      <th style={{ width: "35%" }}>{label}</th>
                      <td>{formatValue(value)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
          <button className="btn btn-primary btn-block" onClick={onClose}>
            Kapat
          </button>
        </>
      )}
    </Modal>
  );
};

export default FormPreviewModal;
